<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="secondary">edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Reset Moderator Password</span>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.native="forgot()" :loading="loading">Reset Password</v-btn>
        <v-btn color="primary" @click.native="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  // import { VueEditor } from 'vue2-editor';
  import { mapActions } from 'vuex';


  export default {
    name: 'DlgModeratorsForgot',
    components: {
      // VueEditor,
    },
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    props: ['moderator'],
    methods: {
      ...mapActions({
        moderatorForgot: 'admin/moderators/forgot',
        memberRead: 'admin/moderators/read',
      }),
      forgot() {
        this.loading = true;
        this.moderatorForgot({ username: this.moderator.username })
          .then((res) => {
            this.loading = false;
            if (res) {
              this.memberRead();
              this.dialog = false;
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
